import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { ListPageBase } from '../../../shared/components/list-page-base/list-page-base';
import { ExportExcelFromGridService } from '../../../shared/services/export-excel-from-grid.service';
import { StatePersistingService } from '../../../shared/services/state-persisting.service';
import { GridSettings } from '../../../shared/models/grid/grid-settings';
import { CustomerObjectServiceCallsService } from '../customer-object-service-calls.service';
import { CustomerObjectNeedServiceCallListItem } from '../../../shared/models/customer-object-service-calls/customer-object-need-service-call-list-item';
import { DataSourceRequestState, FilterDescriptor, isCompositeFilterDescriptor } from '@progress/kendo-data-query';
import { DialogService } from '@progress/kendo-angular-dialog';
import { CustomerObjectServiceCallComponent } from '../customer-object-service-call/customer-object-service-call.component';
import { CustomerObjectServiceCallDto } from '../../../shared/models/customer-object-service-calls/customer-object-service-call.dto';
import { LookupService } from '../../../shared/services/lookup.service';
import { KeyValueObject } from '../../../shared/models/core/KeyValueObject';
import { RequestType } from '../../../shared/enums/request-type.enum';

@Component({
	selector: 'customer-object-service-calls-list',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss',
		'../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class CustomerObjectServiceCallsListPage extends ListPageBase<CustomerObjectNeedServiceCallListItem> {
	requestCategories: KeyValueObject[] = [];
	requestTypes: KeyValueObject[] = [];

	constructor(
		protected appService: AppService,
		protected router: Router,
		protected dataService: CustomerObjectServiceCallsService,
		protected persistingService: StatePersistingService,
		protected exportExcelFromGridService: ExportExcelFromGridService,
		private dialogService: DialogService,
		private lookupService: LookupService)
	{
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		appService.pageTitle = 'Сервисное обслуживание';
	}

	public enableSaveGridSettings: boolean = true;
	public gridSettingsStorageKey: string = "service-calls-grid-settings";
	public gridSettingsFilterStorageKey: string = "service-calls-grid-filter-settings";

	public gridSettingsFilter: GridSettings = {
		state: {
			skip: 0,
			take: 100,
			sort: [{ field: 'contragentName', dir: 'asc' }],
			filter: { logic: 'and', filters: [{ field: 'isPostponed', operator: 'eq', value: false }] },
		},
		columnsConfig: [
			{
				orderIndex: 0,
				field: 'contragentName',
				title: 'Клиент',
				filter: 'string',
				filterable: true,
				width: 260,
				hidden: false
			},
			{
				orderIndex: 1,
				field: 'contragentPhone',
				title: 'Телефон клиента',
				filter: 'string',
				filterable: true,
				width: 200,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'customerObjectAddress',
				title: 'Адрес объекта',
				filter: 'string',
				filterable: true,
				width: 260,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'requestCategoryName',
				title: 'Линейка продукта',
				filter: 'lookup',
				filterable: true,
				width: 260,
				hidden: false
			},
			{
				orderIndex: 4,
				field: 'agreementNumber',
				title: 'Договор',
				filter: 'string',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 5,
				field: 'performerUserName',
				title: 'Ответственный инженер',
				filter: 'string',
				filterable: true,
				width: 220,
				hidden: false
			},
			{
				orderIndex: 6,
				field: 'lastRequestFinishDate',
				title: 'Дата последнего визита',
				filter: 'date',
				filterable: true,
				format: 'dd.MM.yyyy HH:mm',
				width: 350,
				hidden: false
			},
			{
				orderIndex: 7,
				field: 'postponeServiceCallDateTime',
				title: 'Отложено до',
				filter: 'date',
				filterable: true,
				format: 'dd.MM.yyyy HH:mm',
				width: 350,
				hidden: false
			},
			{
				orderIndex: 8,
				field: 'isPostponed',
				title: 'Отложено',
				filter: 'boolean',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 9,
				field: 'lastRequestTypeName',
				title: 'Тип последней заявки',
				filter: 'lookup',
				filterable: true,
				width: 220,
				hidden: false,
				filterField: 'lastRequestTypeId'
			},
			{
				orderIndex: 10,
				field: 'lastComment',
				title: 'Последний комментарий',
				filter: 'string',
				filterable: true,
				width: 320,
				hidden: false
			}
		]
	};

	public gridSettings: GridSettings = {
		state: {
			skip: 0,
			take: 100,
			sort: [{ field: 'contragentName', dir: 'asc' }],
			filter: { logic: 'and', filters: [{ field: 'isPostponed', operator: 'eq', value: false }] },
		},
		columnsConfig: [
			{
				orderIndex: 0,
				field: 'contragentName',
				title: 'Клиент',
				filter: 'string',
				filterable: true,
				width: 260,
				hidden: false
			},
			{
				orderIndex: 1,
				field: 'contragentPhone',
				title: 'Телефон клиента',
				filter: 'string',
				filterable: true,
				width: 200,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'customerObjectAddress',
				title: 'Адрес объекта',
				filter: 'string',
				filterable: true,
				width: 260,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'requestCategoryName',
				title: 'Линейка продукта',
				filter: 'lookup',
				filterable: true,
				width: 260,
				hidden: false
			},
			{
				orderIndex: 4,
				field: 'agreementNumber',
				title: 'Договор',
				filter: 'string',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 5,
				field: 'performerUserName',
				title: 'Ответственный инженер',
				filter: 'string',
				filterable: true,
				width: 220,
				hidden: false
			},
			{
				orderIndex: 6,
				field: 'lastRequestFinishDate',
				title: 'Дата последнего визита',
				filter: 'date',
				filterable: true,
				format: 'dd.MM.yyyy HH:mm',
				width: 190,
				hidden: false
			},
			{
				orderIndex: 7,
				field: 'postponeServiceCallDateTime',
				title: 'Отложено до',
				filter: 'date',
				filterable: true,
				format: 'dd.MM.yyyy HH:mm',
				width: 220,
				hidden: false
			},
			{
				orderIndex: 8,
				field: 'isPostponed',
				title: 'Отложено',
				filter: 'boolean',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 9,
				field: 'lastRequestTypeName',
				title: 'Тип последней заявки',
				filter: 'lookup',
				filterable: true,
				width: 220,
				hidden: false,
				filterField: 'lastRequestTypeId'
			},
			{
				orderIndex: 10,
				field: 'lastComment',
				title: 'Последний комментарий',
				filter: 'string',
				filterable: true,
				width: 320,
				hidden: false
			}
		]
	};

	onListPageInit(): void {
		this.ensureDefaultIsPostponedFilter();
		this.lookupService.getData('request-categories', null).subscribe(data => this.requestCategories = data);
		this.lookupService.getData('request-types', null).subscribe(data =>
			this.requestTypes = data); /*data.filter(x =>
				x.id === <number>RequestType.service || x.id === <number>RequestType.serviceAgreement));*/
	}

	private ensureDefaultIsPostponedFilter(): void {
		const settings = this.gridSettings as GridSettings & { isPostponedDefaultNoApplied?: boolean };
		if (settings.isPostponedDefaultNoApplied) {
			return;
		}

		if (!this.gridSettings.state.filter) {
			this.gridSettings.state.filter = { logic: 'and', filters: [] };
		}

		const hasIsPostponedFilter = this.gridSettings.state.filter.filters.some(f =>
			!isCompositeFilterDescriptor(f) && (<FilterDescriptor>f).field === 'isPostponed');

		if (!hasIsPostponedFilter) {
			this.gridSettings.state.filter.filters.push({ field: 'isPostponed', operator: 'eq', value: false });
		}

		settings.isPostponedDefaultNoApplied = true;
		this.saveGridSettings();
	}

	public loadData(state: DataSourceRequestState = this.gridSettings.state): void {
		this.setGridSettingsState(this.gridSettings);
		super.loadData(state);
	}

	processListItems(items: CustomerObjectNeedServiceCallListItem[]): void {
		items.forEach(x => {
			if (x.lastRequestFinishDate != null) {
				x.lastRequestFinishDate = this.appService.parseDate(x.lastRequestFinishDate);
			}
			if (x.postponeServiceCallDateTime != null) {
				x.postponeServiceCallDateTime = this.appService.parseDate(x.postponeServiceCallDateTime);
			}
		});
	}

	public cellClick({ dataItem }: any): void {
		const dialogRef = this.dialogService.open({
			content: CustomerObjectServiceCallComponent,
			title: 'Детали объекта',
			width: '800px'
		});

		const dialog = <CustomerObjectServiceCallComponent>dialogRef.content.instance;
		dialog.customerObjectId = dataItem.customerObjectId;

		dialog.refreshCallsEvent.subscribe(() => {
			this.loadGridData();
		});
	}
}

